import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deleteProductExpirationPromotionsAction = createAsyncThunk(
    'price/deleteProductExpirationPromotionsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ EXPIRATION_PROMOTIONS_PATH }/product/${ data.productId }`, { data: data.form });
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteProductExpirationPromotionsSlice = createSlice({
    name: 'deleteProductExpirationPromotionsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteProductExpirationPromotionsAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteProductExpirationPromotionsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteProductExpirationPromotionsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteProductExpirationPromotionsState = (state) => state.price.deleteProductExpirationPromotions;
export default deleteProductExpirationPromotionsSlice.reducer;
